// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__l3XDQ","l4":"Loader_l4__baTIt"};